const doc = [({"container":"align-center p-t-40", "title":"gray-700 medium"})];
module.exports = doc.length <= 1 ? doc[0] : doc;